import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import { useNavigate, Link, useLocation, useLoaderData } from 'react-router-dom';
import style from "../../../css/Slide.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useSearchParams } from "react-router-dom";
import "./package.css"

function Operating({ serverchose, onSelectedChildSystem, onselectNameVersionSystem, cookieData }) {
    const location = useLocation();
    const isCreatePage = location.pathname === '/wh-panel/create';

    const [selectedType, setSelectedType] = useState("Operating System");
    const [images, setImages] = useState([]);
    const [selectedVersion, setSelectedVersion] = useState(null);
    const [selectedNameVersion, setSelectedNameVersion] = useState(null);

    const [filterTypeAPP, setfilterTypeAPP] = useState([]);
    const [typeAppSelected, setTypeAPPSelected] = useState(null);
    const [expandedSystem, setExpandedSystem] = useState(null);
    const [regionOpen, setRegionOpen] = useState(false);

    const [itemsPerPage, setItemsPerPage] = useState(8);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");

    const selectedImage = images.find((type) => type.name === selectedType);
    console.log("images", images)
    const selectedTypeApp = images.find((type) => type.name === selectedType && type.parent == 2);

    let filteredImage = [];

    if (selectedType === "Operating System") {
        filteredImage = selectedImage ? selectedImage.images : [];
    } else if (selectedType === "WHPanel") {
        filteredImage = selectedImage ? selectedImage.images : [];

    }
    else if (selectedType === "Marketplace Apps") {
        filteredImage = selectedImage ? selectedImage.children
            .flatMap(child => child.images) : [];
        if (typeAppSelected) {
            filteredImage = filteredImage.filter(image => image.category_id === typeAppSelected);
        }
    }
    const HandleSelectType = (type) => {
        setRegionOpen(false);
        setTypeAPPSelected(type);
    }
    // console.log("selectedImage.children", selectedImage.children)
    const [searchParams] = useSearchParams();
    const { t, i18n } = useTranslation();
    const updateImageInCookies = (newImageId) => {
        const searchParams = new URLSearchParams(location.search);
        const packageValue = searchParams.get("package") || '';
        const region = searchParams.get("region") || '';
        const server = searchParams.get("server") || '';

        const queryString = `package=${packageValue}&region=${region}&server=${server}&images=${newImageId}`;

        console.log("Updating cookies with new image selection:", queryString);

        // Cookies.set('redirectURLPublic', queryString, { expires: 1 });
        localStorage.setItem('redirectURLPublic', queryString);
    };


    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(language);
    }, [i18n]);

    useEffect(() => {
        // Kiểm tra nếu trang hiện tại là '/wh-panel/create', thì mặc định chọn "WH Panel"
        if (isCreatePage) {
            setSelectedType("WHPanel");
        }
    }, [isCreatePage]);

    useEffect(() => {
  
        if (selectedVersion) {
            console.log("selectedVersion", selectedVersion);
            console.log("images", images);
            console.log("selectedType", selectedType);
            const selectedImageGroup = images.find((imgGroup) => imgGroup.name === selectedType);

            let filteredImages = [];

            if (selectedImageGroup) {
                if (selectedImageGroup.children && selectedImageGroup.children.length > 0) {
                    filteredImages = selectedImageGroup.children
                        .flatMap((child) => child.images)
                        .filter((img) => img.name === selectedVersion.systemName && img.version === selectedVersion.version);
                } else {
                    filteredImages = selectedImageGroup.images
                        .filter((img) => img.name === selectedVersion.systemName && img.version === selectedVersion.version);
                }
                updateImageInCookies(selectedVersion.id);

            }

            console.log("filteredImages", filteredImages);

            const filteredIds = filteredImages.map((img) => img.id);
            console.log("filteredIds", filteredIds);

            if (filteredIds.length > 0) {
                onSelectedChildSystem({
                    filteredIds,
                    type: isCreatePage ? "WHPanel" : selectedType,
                });
            }

            if (onselectNameVersionSystem) {
                onselectNameVersionSystem(selectedVersion);
            }
        }

    }, [selectedVersion, images, selectedType, isCreatePage]);

    // useEffect(() => {
    //     if (serverchose?.categories) {
    //         const filterImages = serverchose.categories.filter(
    //             (category) => category.type === "image"
    //         );
    //         setImages(filterImages);
    //     }
    // }, [serverchose, selectedType]);
    useEffect(() => {
        if (serverchose?.categories && Array.isArray(serverchose.categories)) {
            const filterImages = serverchose.categories.filter(category => category.type === "image");
            const selectedImage = filterImages.find((type) => type.name === selectedType);

            if (isCreatePage) {
                const whPanelImages = filterImages.filter(image => image.name === "WHPanel");
                setImages(whPanelImages);
                setSelectedType("WHPanel");

                if (whPanelImages.length > 0 && whPanelImages[0].images.length > 0) {
                    const defaultImage = whPanelImages[0].images[0];

                    setSelectedVersion({
                        id: defaultImage.id,
                        version: defaultImage.version,
                        systemName: defaultImage.name,
                    });
                    onSelectedChildSystem({ defaultImage, type: "WHPanel" });

                    updateImageInCookies(defaultImage.id);
                    if (onselectNameVersionSystem) {
                        onselectNameVersionSystem({
                            id: defaultImage.id,
                            version: defaultImage.version,
                            systemName: defaultImage.name,
                        });
                    }

                }
            } else {
                const nonWhPanelImages = filterImages.filter(image => image.name !== "WHPanel");
                setImages(nonWhPanelImages);
                const selectedImage = filterImages.find((type) => type.name === "Marketplace Apps");

                setfilterTypeAPP(selectedImage?.children)

            }
        }
    }, [serverchose, isCreatePage]);

    console.log("filterTypeAPP", filterTypeAPP)

    console.log("images", images)
    console.log("typeAppSelected", typeAppSelected)

    useEffect(() => {
        const imageid = Number(cookieData?.images);
        console.log("imageid", imageid);

        let imageURL = null;
        let category = null;
        let category2 = null;
        let detectedType = "Operating System";

        if (isCreatePage) {
            detectedType = "WHPanel";

        }


        if (images.length === 0) return;

        category = images.find(item =>
            item.children?.some(child =>
                child.images.some(img => img.id === imageid)
            )
        );
        category2 = images.flatMap(row =>
            row.children ? row.children.flatMap(child => child.images.filter(img => img.id == imageid)) : []
        );

        if (category2.length > 0) {
            setTypeAPPSelected(category2[0]?.category_id);
        }


        if (category) {
            imageURL = category?.children
                .flatMap(child => child.images)
                .find(img => img.id === imageid);
            detectedType = "Marketplace Apps";
        } else {
            category = images.find(item =>
                item.images.some(img => img.id === imageid)
            );

            imageURL = category?.images.find(img => img.id === imageid);
        }

        if (!imageURL) {
            console.error("Không tìm thấy imageURL");
            return;
        }

        if (!cookieData?.manualSelection && detectedType !== selectedType) {
            setSelectedType(detectedType);
        }

        const firstMatch = (detectedType === "Marketplace Apps"
            ? category?.children.flatMap(child => child.images)
            : category?.images
        )?.find(item => item.name === imageURL?.name);

        const version = imageURL?.version;
        const systemName = imageURL?.name;

        if (firstMatch) {
            setSelectedVersion({
                id: firstMatch.id,
                version,
                systemName,
            });
            updateImageInCookies(firstMatch.id);

        } else {
            setSelectedVersion({ imageid, version, systemName });
        }
    }, [images, serverchose, isCreatePage]);


    console.log("selectedType", selectedType)

    const handleSelectVersion = (id, version, systemName) => {
        setSelectedVersion({ id, version, systemName });

        const selectedVersionn = parseFloat(version);
        const filteredIds = filteredImage
            .filter((item) => item.version === selectedVersionn && item.name === systemName)
            .map((item) => item.id);
        if (onSelectedChildSystem) {
            if (isCreatePage) {
                onSelectedChildSystem({ filteredIds, type: "WH Panel" });
            } else {
                onSelectedChildSystem({ filteredIds });
            }
        }

    };
    useEffect(
        () => {
            onselectNameVersionSystem(selectedVersion)
        }
    )

    useEffect(() => {
        setCurrentPage(1); // Reset về trang đầu tiên khi thay đổi số lượng hiển thị
    }, [itemsPerPage]);

    const totalPages = Math.ceil(filteredImage.length / itemsPerPage);
    const displayedImages = selectedType === "Marketplace Apps"
        ? filteredImage.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
        : filteredImage; // Không áp dụng phân trang cho Operating System


    // console.log("selectedVersion", selectedVersion)

    const handleExpandDropdown = (id) => {
        setExpandedSystem((prev) => (prev === id ? null : id));
    };

    const renderPackageTabs = () => (
        <div className="sv-type-list mb-2">
            <ul className="nav nav-tabs">
                {images
                    .filter((type) => {
                        // Nếu đang ở trang '/wh-panel/create', chỉ hiển thị tab "WH Panel"
                        if (isCreatePage) {
                            return type.name === "WHPanel";
                        }
                        return true; // Nếu không ở trang tạo, hiển thị tất cả các loại image
                    })
                    .map((type) => (
                        <li key={type.id} className="nav-item">
                            <button
                                className={`nav-link ${selectedType === type.name ? "active" : ""}`}
                                onClick={() => {
                                    setSelectedType(type.name);
                                    setTypeAPPSelected(null);
                                    setSearchTerm("");
                                    cookieData.manualSelection = true;
                                }}
                            >
                                {t(type.name)}
                            </button>
                        </li>
                    ))}
            </ul>
        </div>

    );

    const renderSystems = () => {
        // const uniqueSystems = displayedImages
        //     .filter((system) => system.name.toLowerCase().includes(searchTerm.toLowerCase())) // Lọc theo từ khóa
        //     .filter(
        //         (system, index, self) => index === self.findIndex((s) => s.name === system.name)
        //     );
        const uniqueSystems = displayedImages
            .filter((system) =>
                selectedType === "Marketplace Apps"
                    ? system.name.toLowerCase().includes(searchTerm.toLowerCase())
                    : true // Không lọc nếu là Operating System
            )
            .filter(
                (system, index, self) => index === self.findIndex((s) => s.name === system.name)
            );



        return (

            <div className="row g-3">

                {selectedType === "Marketplace Apps" &&
                    <div className="row p-0 m-0 h-75" style={{ height: "50px" }}>
                        <div className="col-7 my-3">
                            <input
                                placeholder="Search Apps..."
                                type="search"
                                id="search-apps"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)} // Cập nhật state khi nhập
                                className="form-control shadow-sm"
                            />
                        </div>
                        <div className="col-4 my-3 position-relative d-flex justify-content-end">
                            <div
                                onMouseEnter={() => setRegionOpen(true)}
                                onMouseLeave={() => setRegionOpen(false)}
                            >
                                <a
                                    className="border-0 d-flex justify-content-between align-items-center"
                                    style={{ cursor: "pointer" }}
                                >
                                    <strong>
                                        {typeAppSelected
                                            ? filterTypeAPP.find(row => row.id === typeAppSelected)?.name || "Filter Apps"
                                            : "Filter Apps"}
                                    </strong>
                                    {regionOpen ? "▲" : "▼"}
                                </a>

                                {regionOpen && (
                                    <ul
                                        className="list-group list-group-flush position-absolute bg-white shadow rounded border"
                                        style={{
                                            zIndex: 10,
                                            top: "100%",
                                            maxHeight: "200px",
                                            width: "170px",
                                            overflowY: "auto",
                                        }}
                                    >
                                        <li
                                            className="list-group-item filter-item"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setTypeAPPSelected(null)}
                                        >
                                            Tất cả
                                        </li>
                                        {filterTypeAPP.map((row, index) => (
                                            <li
                                                key={index}
                                                className={`list-group-item filter-item ${typeAppSelected === row.id ? "selected-item" : ""}`}
                                                onClick={() => HandleSelectType(row?.id)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {row.name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>


                    </div>
                }
                {
                    uniqueSystems
                        .filter((system) => {
                            const versions = filteredImage
                                .filter((s) => s.name === system.name)
                                .map((s) => ({ version: s.version, status: s.status }));
                            const allDisabled = versions.every((v) => v.status === 0);
                            return !allDisabled;
                        })
                        .map((system) => {
                            const versions = filteredImage
                                .filter((s) => s.name === system.name)
                                .map((s) => ({ version: s.version, status: s.status }));


                            return (
                                <div
                                    className="col-lg-3 col-md-4 col-sm-6 col-12 text-center"
                                    key={system.id}
                                    style={{
                                        // opacity: allDisabled ? 0.5 : 1, 
                                        // pointerEvents: allDisabled ? "none" : "auto", 
                                        opacity: 1, // Không làm mờ nữa vì đã lọc trước đó
                                        pointerEvents: "auto", // Cho phép click vì không còn bị vô hiệu hóa
                                    }}
                                >
                                    <div
                                        className={`${style.card} shadow-sm ${selectedVersion?.id === system.id ? `${""} ${style.selected}` : ''}`}
                                        style={{
                                            border:
                                                selectedVersion?.id === system.id
                                                    ? "1px solid #007bff"
                                                    : "1px solid #ddd",
                                            backgroundColor:
                                                selectedVersion?.id === system.id
                                                    ? "rgba(59, 130, 246, 0.1)"
                                                    : "white",
                                            padding: "10px",
                                            textAlign: "center",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            position: "relative",
                                            overflow: "visible",
                                            // maxHeight: "150px",
                                            // height: "130px",
                                            padding: "0px",
                                            margin: "0px",

                                        }}
                                        onClick={() =>
                                            versions.length === 1
                                                ? handleSelectVersion(
                                                    system.id,
                                                    versions[0].version, system.name
                                                )
                                                : handleExpandDropdown(system.id)
                                        }
                                    >

                                        {selectedVersion?.id === system.id && (
                                            <>
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: "0",
                                                        right: "0",
                                                        width: "0",
                                                        height: "0",
                                                        borderStyle: "solid",
                                                        borderWidth: "25px 0 0 25px",
                                                        borderColor: "#007bff transparent transparent transparent",
                                                    }}
                                                ></span>

                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: "1px",
                                                        right: "1px",
                                                        color: "white",
                                                        fontSize: "12px",
                                                        // fontWeight: "bold",
                                                    }}
                                                >
                                                    ✔
                                                </span>
                                            </>
                                        )}
                                        <div style={{ height: "70px", display: "flex", justifyContent: "center" }} >
                                            <img
                                                src={`/${system?.logo}`}
                                                style={{
                                                    maxWidth: "20%",
                                                    height: "auto",
                                                    marginTop: "5px",
                                                    marginRight: "5px",
                                                    marginBottom: "10px",
                                                }}
                                                alt={system?.name || "Logo"}
                                            />
                                        </div>

                                        <h5 style={{ marginBottom: "10px" }}>
                                            {system.name}
                                        </h5>

                                        {versions.length === 1 ? (
                                            <p
                                                style={{
                                                    marginBottom: 0,
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {versions[0].version}                                    </p>
                                        ) : (
                                            <div style={{ position: "relative" }}>
                                                <select
                                                    className={style.formselect}
                                                    value={
                                                        selectedVersion?.id === system.id
                                                            ? selectedVersion.version
                                                            : ""
                                                    }
                                                    onChange={(e) => {
                                                        handleSelectVersion(system.id, e.target.value, system.name);
                                                    }}
                                                    size={
                                                        expandedSystem === system.id
                                                            ? versions.length + 1
                                                            : 1
                                                    }
                                                    style={{
                                                        position: "absolute",
                                                        left: "0",
                                                        width: "100%",
                                                        borderRadius: "4px",
                                                        backgroundColor: "rgba(255, 255, 255,1)",
                                                        border: "1px solid rgb(125, 174, 174,0.3)",
                                                        zIndex: 1000,
                                                        color: "#000",
                                                        overflow: "hidden",
                                                        transition: "all 0.1s ease", // Hiệu ứng chuyển đổi mượt
                                                    }}
                                                    onMouseEnter={(e) =>
                                                        (e.target.style.backgroundColor = "rgba(255, 255, 255,1)")
                                                    }
                                                    onMouseLeave={(e) =>
                                                        (e.target.style.backgroundColor = "rgba(255, 255, 255,1)")
                                                    }
                                                >
                                                    <option
                                                        style={{
                                                            fontSize: "1rem",
                                                        }}
                                                        value=""
                                                        disabled
                                                    >
                                                        {t("Select version")}
                                                    </option>
                                                    {filteredImage
                                                        .filter((s) => s.name === system.name)
                                                        .map((item, idx) => (
                                                            <option
                                                                key={idx}
                                                                value={item.version}
                                                                style={{
                                                                    fontSize: "15px",
                                                                    padding: "5px",
                                                                    transition: "background-color 0.1s ease",
                                                                    color: item.status === 0 ? "gray" : "black",
                                                                    backgroundColor: item.status === 0 ? "rgba(211, 211, 211, 0.5)" : "white", // Nền xám nếu status = 0
                                                                    cursor: item.status === 0 ? "not-allowed" : "pointer",
                                                                }}
                                                                disabled={item.status === 0}
                                                                onMouseEnter={(e) => {
                                                                    if (item.status !== 0) {
                                                                        e.target.style.backgroundColor = "#007bff";
                                                                        e.target.style.color = "#fff";
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (item.status !== 0) {
                                                                        e.target.style.backgroundColor = "transparent";
                                                                        e.target.style.color = "#000";
                                                                    }
                                                                }}
                                                            >
                                                                {item.version}
                                                            </option>
                                                        ))}
                                                </select>

                                            </div>

                                        )}
                                    </div>
                                </div>
                            );
                        })
                }

                {selectedType === "Marketplace Apps" && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="d-flex align-items-center">
                            <button
                                className="btn btn-outline-secondary me-2"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}
                            >
                                &larr;
                            </button>

                            <select
                                className="form-select w-auto"
                                value={currentPage}
                                onChange={(e) => setCurrentPage(Number(e.target.value))}
                            >
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                    <option key={page} value={page}>{page}</option>
                                ))}
                            </select>

                            <button
                                className="btn btn-outline-secondary ms-2"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}
                            >
                                &rarr;
                            </button>
                        </div>

                        <div className="d-flex align-items-center">
                            <label className="me-2">Show:</label>
                            <select
                                className="form-select w-auto"
                                value={itemsPerPage}
                                onChange={(e) => {
                                    setItemsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                {[8, 16, 32, 64].map((size) => (
                                    <option key={size} value={size}>{size}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}


            </div >

        );
    };

    return (
        <>
            {!isCreatePage && (
                <div style={{ margin: 0, padding: 0 }} className="container">
                    {renderPackageTabs()}
                    {renderSystems()}
                </div>
            )}


        </>
    )
}

export default Operating;
